import Seat from './Seat.jsx';
import FreeSeatingArea from './FreeSeatingArea.jsx';
// Styles

function switchElementType(element) {
	switch (element.type) {
		case 'SEAT':
			return <Seat element={element} />;
		case 'FREE_SEATING':
			return <FreeSeatingArea element={element} />;
		default:
			return null;
	}
}

function SeatingplanElement(props) {
	return switchElementType(props.element);
}

export default SeatingplanElement;

